// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"section-indicator-module--wrapper--3TetR","indicator":"section-indicator-module--indicator--DTWfi","active":"section-indicator-module--active--3AGBc"};